import { AbortControllerManager } from '../abortControllerManager';
import { authClient } from '../client';
import {
  IChatMessageRequest,
  TChatMessageResponse,
  TChatResponse,
  IPatchChatRequest,
  IPostChatEventRequest,
  IPutChatParticipantsRequest,
  ICreateChatRequest,
  TChatsResponse,
  IGetChatsParams,
} from '@/types/chats';

class ChatApi extends AbortControllerManager {
  private readonly CHAT_URL = '/v2/chats';

  constructor() {
    super();
  }

  createChat(body: ICreateChatRequest): Promise<TChatResponse> {
    const signal = this.createAbortController('createChat');
    return authClient.post(this.CHAT_URL, body, { signal });
  }

  getChats(params?: IGetChatsParams): Promise<TChatsResponse> {
    const signal = this.createAbortController('getChats');
    return authClient.get(`${this.CHAT_URL}`, { params, signal });
  }

  getChat(id: string): Promise<TChatResponse> {
    const signal = this.createAbortController(`getChat-${id}`);
    return authClient.get(`${this.CHAT_URL}/${id}`, { signal });
  }

  patchChat(id: string, body: IPatchChatRequest): Promise<void> {
    const signal = this.createAbortController(`patchChat-${id}`);
    return authClient.patch(`${this.CHAT_URL}/${id}`, body, { signal });
  }

  putChatParticipants(
    id: string,
    body: IPutChatParticipantsRequest,
  ): Promise<void> {
    const signal = this.createAbortController(
      `putChatParticipants-${id}-${body.user_institution_role_id}`,
    );
    return authClient.put(`${this.CHAT_URL}/${id}/participants`, body, {
      signal,
    });
  }

  sendMessageInChat(
    id: string,
    body: IChatMessageRequest,
  ): Promise<TChatMessageResponse> {
    const signal = this.createAbortController(`sendMessageInChat-${id}`);
    return authClient.post(`${this.CHAT_URL}/${id}/message`, body, { signal });
  }

  postChatEvent(id: string, body: IPostChatEventRequest): Promise<void> {
    const signal = this.createAbortController(
      `postChatEvent-${id}-${body.user_institution_role_id}-${body.type}`,
    );
    return authClient.post(`${this.CHAT_URL}/${id}/event`, body, { signal });
  }

  // createAbortController is not used here because multiple requests need to be sent simultaneously
  putMarkMessagesAsRead(
    id: string,
    body: { message_ids: string[] },
  ): Promise<void> {
    return authClient.put(`${this.CHAT_URL}/${id}/mark-read`, body);
  }
}

export const chatApi = new ChatApi();
